<template>
  <div>
    <el-form :inline="true">
      <el-form-item>
        <el-input v-model="searchForm.customerName" placeholder="名称" clearable>
        </el-input>
      </el-form-item>
      <el-form-item>
        <el-input v-model="searchForm.idcard" placeholder="身份证" clearable>
        </el-input>
      </el-form-item>
      <el-form-item>
        <el-input v-model="searchForm.phone" placeholder="电话" clearable>
        </el-input>
      </el-form-item>
   <el-form-item label="申请状态" prop="state">
            <el-select v-model="searchForm.state" placeholder="全部">
              <el-option label="审核中" value="1"></el-option>
              <el-option label="审核成功" value="2"></el-option>
              <el-option label="审核失败" value="3"></el-option>
            </el-select>
          </el-form-item>
      <el-form-item>
        <el-button @click="getRoleList(searchForm)">搜索</el-button>
      </el-form-item>

      <el-form-item>
        <el-popconfirm title="这是确定批量删除吗？" @confirm="delHandle(null)">
          <el-button type="danger" slot="reference" :disabled="delBtlStatu"
            >批量删除</el-button
          >
        </el-popconfirm>
      </el-form-item>
    </el-form>

    <el-table
      ref="multipleTable"
      :data="tableData"
      tooltip-effect="dark"
      style="width: 100%"
      border
      stripe
      @selection-change="handleSelectionChange"
    >
      <el-table-column type="selection" width="55"> </el-table-column>

      <el-table-column prop="customerName" label="姓名" width="120">
      </el-table-column>
      <el-table-column prop="idcard" label="身份证" show-overflow-tooltip>
      </el-table-column>
      <el-table-column prop="birthday" label="生日" show-overflow-tooltip>
      </el-table-column>
      <el-table-column
        prop="gender"
        label="性别"
        :formatter="genderFormat"
        show-overflow-tooltip
      >
      </el-table-column>
      <el-table-column prop="phone" label="手机号" show-overflow-tooltip>
      </el-table-column>
       <el-table-column prop="state"  :formatter="stateFormat" label="审核状态" show-overflow-tooltip>
      </el-table-column>
      <el-table-column prop="icon" label="操作">
        <template slot-scope="scope">
              <el-button type="text" @click="chakan(scope.row)">查看</el-button>
          <el-divider direction="vertical" v-if='scope.row.state != 2'></el-divider>
          <el-button type="text" v-if='scope.row.state != 2' @click="editHandle(scope.row)">审核</el-button>
          <el-divider direction="vertical"></el-divider>

          <template>
            <el-popconfirm
              title="这是一段内容确定删除吗？"
              @confirm="delHandle(scope.row.id)"
            >
              <el-button type="text" slot="reference">删除</el-button>
            </el-popconfirm>
          </template>
        </template>
      </el-table-column>
    </el-table>
    <el-pagination
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      layout="total, sizes, prev, pager, next, jumper"
      :page-sizes="[10, 20, 50, 100]"
      :current-page="current"
      :page-size="size"
      :total="total"
    >
    </el-pagination>

    <!--新增对话框-->
    <el-dialog
      title="提示"
      :visible.sync="dialogVisible"
      width="600px"
      :before-close="handleClose"
    >
      <el-form
        :model="editForm"
        :rules="editFormRules"
        ref="editForm"
        label-width="100px"
        class="demo-editForm"
      >
        <el-form-item label="状态" prop="state" label-width="100px">
          <el-radio-group v-model="editForm.state">
            <el-radio :label="1">审核中</el-radio>
            <el-radio :label="2">审核成功</el-radio>
            <el-radio :label="3">审核失败</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item
          label="审核失败描述"
          prop="notDescribe"
          label-width="100px"
        >
          <el-input
            v-model="editForm.notDescribe"
            autocomplete="off"
          ></el-input>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="submitForm('editForm')"
            >立即创建</el-button
          >
          <el-button @click="resetForm('editForm')">重置</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>

    <!--新增查看对话框-->
    <el-dialog
      title="提示"
      :visible.sync="chakanFlag"
      width="80rem"
      :before-close="chakanClose"

    >
      <el-form
        :model="editForm"
        :rules="editFormRules"
        ref="editForm"
        :inline="true"
        label-width="100px"
        class="demo-editForm"
      >
        <el-form-item label="姓名" prop="customerName" label-width="100px">
          <el-input
            v-model="editForm.customerName"
            autocomplete="off"
            :readonly="true"
          ></el-input>
        </el-form-item>
        <el-form-item label="身份证" prop="idcard" label-width="100px">
          <el-input
            v-model="editForm.idcard"
            autocomplete="off"
            :readonly="true"
          ></el-input>
        </el-form-item>
        <el-form-item label="手机号" prop="phone" label-width="100px">
          <el-input
            v-model="editForm.phone"
            autocomplete="off"
            :readonly="true"
          ></el-input>
        </el-form-item>
        <el-form-item label="生日" prop="birthday" label-width="100px">
          <el-input
            v-model="editForm.birthday"
            autocomplete="off"
            :readonly="true"
          ></el-input>
        </el-form-item>
        <el-form-item label="性别" prop="gender" label-width="100px">
          <el-select
            v-model="editForm.gender"
            placeholder="全部"
            ref="proLabel"
             :disabled="true"
          >
            <el-option label="男" value="1"></el-option>
            <el-option label="女" value="0"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="民族" prop="nation" label-width="100px">
          <el-input
            v-model="editForm.nation"
            autocomplete="off"
            :readonly="true"
          ></el-input>
        </el-form-item>
        <el-form-item label="省" prop="province" label-width="100px">
          <el-select
            v-model="editForm.province"
            placeholder="全部"
            ref="proLabel"
            @change="getcity(editForm.province)"
            :disabled="true"
          >
            <!-- <template v-for="item in province">
              <el-option
                :label="item.addName"
                :value="item.addCode"
              ></el-option>
            </template> -->
          </el-select>
        </el-form-item>
        <el-form-item label="市" prop="city" label-width="100px">
          <el-select
            v-model="editForm.city"
            placeholder="全部"
            ref="cityLabel"
            @change="getarea(editForm.city)"
            :disabled="true"
          >
            <!-- <template v-for="item in city">
              <el-option
                :label="item.addName"
                :value="item.addCode"
              ></el-option>
            </template> -->
          </el-select>
        </el-form-item>
        <el-form-item label="区" prop="area" label-width="100px">
          <el-select
            v-model="editForm.area"
            placeholder="全部"
            ref="areaLabel"
            :disabled="true"
          >
            <!-- <template v-for="item in area">
              <el-option
                :label="item.addName"
                :value="item.addCode"
              ></el-option>
            </template> -->
          </el-select>
        </el-form-item>
        <el-form-item label="街道" prop="street" label-width="100px">
             <el-select
            v-model="editForm.street"
            placeholder="全部"
            ref="streetLabel"
            :disabled="true"
          >
            <!-- <template v-for="item in street">
              <el-option
                :label="item.addName"
                :value="item.addCode"
              ></el-option>
            </template> -->
          </el-select>
        </el-form-item>
        <el-form-item label="社区" prop="belongArea" label-width="100px">
          <el-input
            v-model="editForm.belongArea"
            autocomplete="off"
            :readonly="true"
          ></el-input>
        </el-form-item>
        <el-form-item label="地址" prop="address" label-width="100px">
          <el-input
            v-model="editForm.address"
            autocomplete="off"
            :readonly="true"
          ></el-input>
        </el-form-item>
      </el-form>
    </el-dialog>
  </div>
</template>

<script>
export default {
  name: "customer",
  data() {
    return {
      searchForm: {},
      delBtlStatu: true,

      total: 0,
      size: 10,
      current: 1,
     chakanFlag: false,
      dialogVisible: false,
      editForm: {},
      userInfo: {
        id: "",
        username: "",
        avatar: "",
        roles: "",
      },
      tableData: [],

      editFormRules: {
        // customerName: [{ required: true, message: "请输入姓名", trigger: "blur" }],
        // idcard: [{ required: true, message: "请输入身份证", trigger: "blur" }],
        // gender: [{ required: true, message: "请输入性别", trigger: "blur" }],
        // phone: [{ required: true, message: "请输入电话", trigger: "blur" }],
        // address: [{ required: true, message: "请选择地址", trigger: "blur" }],
      },

      multipleSelection: [],

      permDialogVisible: false,
      permForm: {},
      defaultProps: {
        children: "children",
        label: "name",
      },
      permTreeData: [],
      options: [],
    };
  },
  created() {
    this.$axios.get("/gw/sys/menu/list").then((res) => {
      this.permTreeData = res.data.data;
    });
    const userInfo = localStorage.getItem("userInfo");
    if (userInfo != null) {
      this.userInfo = JSON.parse(userInfo);
    }
    this.getRoleList();
  },
  methods: {
    stateFormat(row) {
      if (row.state == "1") {
        return "审核中";
      } else if(row.state == "2") {
        return "审核成功";
      }else if(row.state == "3") {
        return "审核失败";
      }
    },
    genderFormat(row){
        if (row.gender == "1") {
        return "男";
      } else {
        return "女";
      }
    },
    chakanClose() {
      this.chakanFlag = false;
    },
    chakan(res) {
      this.editForm = res;
      this.chakanFlag = true;
    },
    toggleSelection(rows) {
      if (rows) {
        rows.forEach((row) => {
          this.$refs.multipleTable.toggleRowSelection(row);
        });
      } else {
        this.$refs.multipleTable.clearSelection();
      }
    },
    handleSelectionChange(val) {

      this.multipleSelection = val;

      this.delBtlStatu = val.length == 0;
    },

    handleSizeChange(val) {
      this.size = val;
      this.getRoleList();
    },
    handleCurrentChange(val) {
      this.current = val;
      this.getRoleList();
    },

    resetForm(formName) {
      this.$refs[formName].resetFields();
      this.dialogVisible = false;
      this.editForm = {};
    },
    handleClose() {
      this.resetForm("editForm");
    },

    getRoleList(res) {
      const uid = this.userInfo.id;
      var obj = {};
      if (res != null) {
        obj.customerName = res.customerName;
         obj.phone = res.phone;
         obj.idcard = res.idcard;
         obj.state = res.state;
      }

      obj.createId = uid;
      this.$axios.post("/gw/customer/list/0", obj).then((res) => {
        this.tableData = res.data.data.records;
        this.size = res.data.data.size;
        this.current = res.data.data.current;
        this.total = res.data.data.total;
      });
    },

    submitForm(formName) {
      this.editForm.createId = this.userInfo.id;
      this.editForm.createName = this.userInfo.username;
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.$axios.post("/gw/customer/update", this.editForm).then((res) => {
            this.$message({
              showClose: true,
              message: "恭喜你，操作成功",
              type: "success",
              onClose: () => {
                this.getRoleList();
              },
            });

            this.dialogVisible = false;
            this.resetForm(formName);
          });
        } else {
          return false;
        }
      });
    },
    editHandle(data) {
        this.$axios.post("/gw/customer/userAsCus", data).then((res) => {
              if(res.data.code == 200){
                  this.$message({
              showClose: true,
              message: "恭喜你，审核成功",
              type: "success",
              onClose: () => {
                this.getRoleList();
              },
            });

              }
          });
    },
    delHandle(id) {
      var ids = [];

      if (id) {
        ids.push(id);
      } else {
        this.multipleSelection.forEach((row) => {
          ids.push(row.id);
        });
      }


      this.$axios.post("/gw/customer/delete", ids).then((res) => {
        this.$message({
          showClose: true,
          message: "恭喜你，操作成功",
          type: "success",
          onClose: () => {
            this.getRoleList();
          },
        });
      });
    },
    permHandle(id) {
      this.permDialogVisible = true;

      this.$axios.get("/gw/sys/role/info/" + id).then((res) => {
        this.$refs.permTree.setCheckedKeys(res.data.data.menuIds);
        this.permForm = res.data.data;
      });
    },

    submitPermFormHandle(formName) {
      var menuIds = this.$refs.permTree.getCheckedKeys();


      this.$axios
        .post("/gw/sys/role/perm/" + this.permForm.id, menuIds)
        .then((res) => {
          this.$message({
            showClose: true,
            message: "恭喜你，操作成功",
            type: "success",
            onClose: () => {
              this.getRoleList();
              this.$router.go(0);
            },
          });
          this.permDialogVisible = false;
          this.resetForm(formName);
        });
    },
  },
};
</script>

<style scoped>
.el-pagination {
  float: right;
  margin-top: 22px;
}
</style>
